import { Card, CardBody, Input, InputGroup, InputGroupText, Button } from 'reactstrap';

/**
 * Generischer Filter-Bar für List-Views.
 *
 * `search` ist optional — wenn weggelassen, wird kein Search-Input gerendert.
 * `extras` ist ein React-Node-Slot für Dropdowns / Status-Filter etc.
 * `onReset` wird auf einem "Zurücksetzen"-Button gebunden, wenn gesetzt.
 */
export function FilterBar({
  search,
  searchPlaceholder = 'Suche…',
  onSearchChange,
  extras,
  onReset,
}) {
  return (
    <Card className="mb-3">
      <CardBody className="py-2">
        <div className="d-flex flex-wrap align-items-center gap-2">
          {onSearchChange && (
            <InputGroup style={{ maxWidth: 320 }}>
              <InputGroupText>🔍</InputGroupText>
              <Input
                type="search"
                value={search ?? ''}
                placeholder={searchPlaceholder}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </InputGroup>
          )}
          {extras}
          {onReset && (
            <Button color="link" size="sm" className="ms-auto" onClick={onReset}>
              Zurücksetzen
            </Button>
          )}
        </div>
      </CardBody>
    </Card>
  );
}
